import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b6ac6bec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row prefix-row" }
const _hoisted_2 = { class: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PhonePrefixSelect = _resolveComponent("PhonePrefixSelect")!
  const _component_Error = _resolveComponent("Error")!
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock("div", {
    class: "field--phone",
    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.setFocusOnPhoneField && _ctx.setFocusOnPhoneField(...args)))
  }, [
    _createElementVNode("div", {
      class: "field--phone__label",
      style: _normalizeStyle({ opacity: _ctx.isLabelShown ? 1 : 0 })
    }, [
      _createElementVNode("span", null, _toDisplayString(_ctx.t(`${_ctx.TRANSLATION_KEY}.phoneNumber`)), 1)
    ], 4),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_PhonePrefixSelect, {
        modelValue: _ctx.formData.phonePrefix,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => (_ctx.formData.phonePrefix = $event)),
          _ctx.emitValue
        ],
        class: "prefix custom-select",
        "only-countries": _ctx.listOfCountriesNew,
        "default-country": _ctx.bindProps.defaultCountry,
        disabled: _ctx.disabled
      }, null, 8, ["modelValue", "only-countries", "default-country", "disabled", "onUpdate:modelValue"])
    ]),
    (_ctx.handlesError)
      ? (_openBlock(), _createBlock(_component_Error, {
          key: 0,
          name: _ctx.name + 'Prefix',
          "value-field": _ctx.formData.phonePrefix
        }, null, 8, ["name", "value-field"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Field, {
        modelValue: _ctx.formData.phone,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.phone = $event)),
        name: _ctx.name,
        type: "text",
        disabled: _ctx.disabled,
        placeholder: _ctx.placeholder,
        "is-validated": false,
        "handles-data-preload": _ctx.handlesDataPreload,
        "is-numeric": true,
        "only-numbers": true,
        onBlur: _ctx.validate,
        onInput: _ctx.emitValue,
        onChange: _ctx.emitValue,
        onPaste: _ctx.emitValue
      }, null, 8, ["modelValue", "name", "disabled", "placeholder", "handles-data-preload", "onBlur", "onInput", "onChange", "onPaste"])
    ])
  ]))
}